import BookingPage from '../../booking-page/base/page';
import TravelPageContentView from './content';


export default class TravelPage extends BookingPage {
    constructor (options = {}) {
        super({
            key: 'travel',
            ...options
        });
    }


    get contentViewClass () {
        return TravelPageContentView;
    }

    onBeforeDestroy () {
        this.checkReactModalPortalDivSpam();
    }
}
